import { Fieldset as FieldsetPrimitive } from "@base-ui/react/fieldset";
import { cn } from "#ui-atoms/lib/utils";
import type { FieldsetParts } from ".";

function BaseFieldset({ className, ...props }: FieldsetPrimitive.Root.Props) {
  return (
    <FieldsetPrimitive.Root
      className={cn("flex w-full min-w-0 max-w-64 flex-col gap-6", className)}
      data-slot="fieldset"
      {...props}
    />
  );
}
function BaseFieldsetLegend({
  className,
  ...props
}: FieldsetPrimitive.Legend.Props) {
  return (
    <FieldsetPrimitive.Legend
      className={cn("font-semibold", className)}
      data-slot="fieldset-legend"
      {...props}
    />
  );
}

export { BaseFieldset, BaseFieldsetLegend };

export const baseFieldsetKit: FieldsetParts = {
  Root: BaseFieldset,
  Legend: BaseFieldsetLegend,
};
